import { useEffect, useState } from "react";
import { Menu, X, Globe } from "lucide-react";
import { openMission } from "./Mission";
import { openReflect } from "./Reflect";
import { Translate } from "./Translate";

const links = [
  { label: "Teachings", href: "#teachings" },
  { label: "Timeline", href: "#timeline" },
  { label: "Sabbath", href: "#sabbath" },
  { label: "Paul", href: "#paul" },
  { label: "History", href: "#history" },
  { label: "Watch", href: "#watch" },
  { label: "Our Stand", href: "#about" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#0A0A0A]/70 backdrop-blur-xl border-b border-[#2B2825]" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center group">
          <img
            src="https://customer-assets.emergentagent.com/job_sabbath-way/artifacts/kaufvsti_ChatGPT%20Image%20Jul%201%2C%202026%2C%2005_36_32%20PM.png"
            alt="The Restoration"
            className="h-16 w-auto object-contain transition-transform duration-500 group-hover:scale-105"
          />
        </a>

        <div className="flex items-center gap-4 md:gap-7">
          <nav className="hidden md:flex items-center gap-7">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm tracking-wide text-[#A39E98] hover:text-[#F4F0EA] transition-colors"
              >
                {l.label}
              </a>
            ))}
            <button
              onClick={openReflect}
              data-testid="nav-reflect-button"
              className="text-sm tracking-wide text-[#A39E98] hover:text-[#F4F0EA] transition-colors"
            >
              Reflect
            </button>
            <button
              onClick={openMission}
              data-testid="nav-mission-button"
              className="text-sm tracking-wide text-[#A39E98] hover:text-[#F4F0EA] transition-colors"
            >
              Our Mission
            </button>
          </nav>

          <div className="flex items-center gap-2" data-testid="language-switcher">
            <Globe strokeWidth={1.5} className="h-4 w-4 text-[#D4AF37] shrink-0" />
            <Translate />
          </div>

          <a
            href="#join"
            data-testid="nav-cta"
            className="hidden md:inline-flex bg-[#D4AF37] text-[#0A0A0A] text-sm font-medium px-6 py-3 hover:bg-[#E5C865] transition-colors"
          >
            Stand With Us
          </a>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-[#F4F0EA]"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X strokeWidth={1} /> : <Menu strokeWidth={1} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#0A0A0A]/95 backdrop-blur-xl border-t border-[#2B2825] px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base text-[#A39E98] hover:text-[#F4F0EA]"
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={() => { setOpen(false); openReflect(); }}
            data-testid="mobile-reflect-button"
            className="text-left text-base text-[#A39E98] hover:text-[#F4F0EA]"
          >
            Reflect
          </button>
          <button
            onClick={() => { setOpen(false); openMission(); }}
            data-testid="mobile-mission-button"
            className="text-left text-base text-[#A39E98] hover:text-[#F4F0EA]"
          >
            Our Mission
          </button>
          <a href="#join" onClick={() => setOpen(false)} className="bg-[#D4AF37] text-[#0A0A0A] text-center font-medium px-6 py-3">
            Stand With Us
          </a>
        </div>
      )}
    </header>
  );
};
